import { useEffect } from 'react';
import { useLocalStorage } from 'react-use';
import { BooleanParam, useQueryParams } from 'use-query-params';

const STORAGE_KEY = 'rg-legacy-mode';

export function useRgVersion() {
  const [{ legacy }, setQuery] = useQueryParams({ legacy: BooleanParam });
  const [storedLegacy, setStoredLegacy] = useLocalStorage<boolean>(
    STORAGE_KEY,
    true,
  );

  const isLegacy = legacy ?? storedLegacy ?? true;

  useEffect(() => {
    if (legacy !== null && legacy !== undefined) {
      setStoredLegacy(legacy);
    }
  }, [legacy, setStoredLegacy]);

  const toggleVersion = () => {
    const newValue = !isLegacy;
    setStoredLegacy(newValue);
    setQuery({ legacy: newValue }, 'pushIn');
  };

  return { isLegacy, toggleVersion };
}
